/* LucyBalu MW 21.10.26: Land- und Sprachwahl (snippets/lb-loc.liquid) – zwei Auswahlfelder + Bestätigen */
(function () {
  if (window.lbLocReady) return;
  window.lbLocReady = true;

  function parseDefaults(raw) {
    var map = {};
    (raw || '').split(/[\n,;]+/).forEach(function (row) {
      var p = row.split('=');
      if (p.length === 2) map[p[0].trim().toUpperCase()] = p[1].trim().toLowerCase();
    });
    return map;
  }

  // Sprachname in der eigenen Sprache (z. B. „Nederlands“). Nicht jede Domain kennt alle Sprachen
  // (lucybalu.ch ohne Niederländisch) – dann liefert der Browser den Namen.
  function langNameFrom(names) {
    return function (l) {
      if (names[l]) return names[l];
      try {
        var n = new Intl.DisplayNames([l], { type: 'language' }).of(l);
        if (n && n !== l) return n.charAt(0).toUpperCase() + n.slice(1);
      } catch (e) {}
      return l.toUpperCase();
    };
  }

  function init(root) {
    if (root.dataset.lbLocInit) return;
    root.dataset.lbLocInit = '1';

    var data = { names: {}, c: {} };
    try { data = JSON.parse(root.querySelector('[data-lb-loc-data]').textContent); } catch (e) {}
    var defaults = parseDefaults(root.getAttribute('data-defaults'));
    var langName = langNameFrom(data.names || {});
    var selC = root.querySelector('[data-lb-loc-country]');
    var selL = root.querySelector('[data-lb-loc-language]');
    var toggle = root.querySelector('[data-lb-loc-toggle]');
    var panel = root.querySelector('.lb-loc__panel');

    // Sprachen passend zum gewählten Land, Standardsprache vorauswählen
    selC.addEventListener('change', function () {
      var langs = data.c[selC.value] || [];
      if (!langs.length) return;
      var keep = selL.value;
      var def = defaults[selC.value];
      var pick = def && langs.indexOf(def) > -1 ? def : (langs.indexOf(keep) > -1 ? keep : langs[0]);
      selL.innerHTML = '';
      langs.forEach(function (l) {
        var o = document.createElement('option');
        o.value = l; o.textContent = langName(l);
        selL.appendChild(o);
      });
      selL.value = pick;
    });

    if (!toggle) return;
    function setOpen(open) {
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      root.classList.toggle('is-open', open);
      if (open) selC.focus({ preventScroll: true });
    }
    root.addEventListener('click', function (e) {
      if (e.target === root && !panel.hidden) { setOpen(false); return; } // Tipp auf den Hintergrund (mobil)
      if (e.target.closest('[data-lb-loc-toggle]')) { setOpen(panel.hidden); return; }
      if (e.target.closest('[data-lb-loc-close]')) { setOpen(false); toggle.focus(); }
    });
    document.addEventListener('click', function (e) {
      if (!panel.hidden && !root.contains(e.target)) setOpen(false);
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) { setOpen(false); toggle.focus(); }
    });
  }

  function initAll() { document.querySelectorAll('[data-lb-loc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
